const THEMES = {
  TRADITIONAL: 'traditional',
  MARKET: 'market',
  PLATINUM: 'platinum'
};

/**
 * Get theme concept from cinema object
 * @param {Object} cinema - Cinema object with market/platinum flags
 * @returns {string} - 'market', 'platinum', or 'traditional'
 */
export const getThemeFromCinema = (cinema) => {
  if (cinema.market) return THEMES.MARKET;
  if (cinema.platinum) return THEMES.PLATINUM;
  return THEMES.TRADITIONAL;
};

/**
 * Get the appropriate icon URL based on active theme and active state
 * @param {Object} icons - Icons object with structure: { traditional: { default, active }, market: {...}, platinum: {...} }
 * @param {boolean} isActive - Whether the menu item is currently active/selected
 * @param {Object} cinema - Optional cinema object to determine theme (if not provided, reads from DOM)
 * @returns {string|null} - Icon URL or null if not found
 */
export const getMenuIcon = (icons, isActive = false, cinema = null) => {
  if (!icons || typeof icons !== 'object') {
    return null;
  }

  // Determine concept from cinema prop or fallback to DOM classes
  let concept;
  if (cinema) {
    concept = getThemeFromCinema(cinema);
  } else {
    concept = THEMES.TRADITIONAL;
    if (document.body.classList.contains('theme-market')) {
      concept = THEMES.MARKET;
    } else if (document.body.classList.contains('theme-platinum')) {
      concept = THEMES.PLATINUM;
    }
  }

  const conceptIcons = icons[concept];
  if (!conceptIcons) {
    return null;
  }

  const state = isActive ? 'active' : 'default';
  return conceptIcons[state] || conceptIcons.default || null;
};

